var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEnclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.421,
    height: 15.421,
    viewBox: "0 0 15.421 15.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close_-_enclosed",
    "data-name": "Close - enclosed",
    transform: "translate(-203 -327.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cancel_FILL0_wght400_GRAD0_opsz48",
    d: "M8.819,15.411,11.71,12.52,14.6,15.411l.81-.81L12.52,11.71l2.891-2.891-.81-.81L11.71,10.9,8.819,8.009l-.81.81L10.9,11.71,8.009,14.6Zm2.891,4.009a7.461,7.461,0,0,1-2.988-.607A7.768,7.768,0,0,1,4.607,14.7a7.7,7.7,0,0,1,0-5.995A7.706,7.706,0,0,1,6.265,6.255,7.9,7.9,0,0,1,8.723,4.607a7.7,7.7,0,0,1,5.995,0,7.7,7.7,0,0,1,4.1,4.1,7.7,7.7,0,0,1,0,5.995,7.9,7.9,0,0,1-1.648,2.458,7.706,7.706,0,0,1-2.448,1.658A7.508,7.508,0,0,1,11.71,19.421Zm0-1.157a6.307,6.307,0,0,0,4.646-1.918,6.332,6.332,0,0,0,1.908-4.636A6.516,6.516,0,0,0,11.71,5.157,6.332,6.332,0,0,0,7.075,7.065,6.307,6.307,0,0,0,5.157,11.71a6.316,6.316,0,0,0,1.918,4.636A6.316,6.316,0,0,0,11.71,18.264ZM11.71,11.71Z",
    transform: "translate(199 323.259)",
    fill: "#b8c4c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEnclosed);
export default __webpack_public_path__ + "static/media/close_enclosed.ff330cdd9cf5557803e007a4a492dcc5.svg";
export { ForwardRef as ReactComponent };